export default "__VITE_ASSET__1ce33edd__"